import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, mergeMap, tap } from "rxjs";
import { LanguagesActions } from "./languages.actions";
import { LanguageService } from "../../services/language.service";
import { Language } from "../../models/language.model";

@Injectable()
export class LanguagesEffect {
  constructor(
    private action$: Actions,
    private languageService: LanguageService
  ) { }

  loadLanguages$ = createEffect(() =>
    this.action$.pipe(
      ofType(LanguagesActions.loadLanguages),
      mergeMap(() =>
        this.languageService.getLanguages().pipe(
          map((languages: Language[]) => LanguagesActions.addLanguages({ languages }))
        )
      )
    )
  );

}